import{Component}from'@theme/component';
import{ThemeEvents,VariantUpdateEvent,ZoomMediaSelectedEvent}from'@theme/events';
export class MediaGallery extends Component{
#c=new AbortController();
connectedCallback(){super.connectedCallback();const{signal}=this.#c,t=this.closest('.shopify-section, dialog');t?.addEventListener(ThemeEvents.variantUpdate,this.#v,{signal});this.refs.zoomDialogComponent?.addEventListener(ThemeEvents.zoomMediaSelected,this.#z,{signal});}
disconnectedCallback(){super.disconnectedCallback();this.#c.abort();}
#v=(e)=>{const s=e.detail.data.html;if(!s)return;const n=s.querySelector('media-gallery');if(!n)return;this.replaceWith(n);};
#z=async(e)=>{this.slideshow?.select(e.detail.index,undefined,{animate:false});};
zoom(i,e){this.refs.zoomDialogComponent?.open(i,e);}
preloadImage(i){const m=this.refs.zoomDialogComponent?.refs.media[i];if(!m)return;this.refs.zoomDialogComponent?.loadHighResolutionImage(m);}
get slideshow(){return this.refs.slideshow;}
get media(){return this.refs.media;}
get presentation(){return this.dataset.presentation;}
}
if(!customElements.get('media-gallery'))customElements.define('media-gallery',MediaGallery);